import { Link } from "react-router-dom";

const TopSales = () => {
  return (
    <>
      <div className="section baseline featured-title">
        <div className="div-block-32">
          <h2 className="header-big">Features</h2>
        </div>
      </div>
      <div className="section">
        <div className="top-sales__favorite">
          <div className="big-product-img">
            <video
              autoPlay
              loop
              muted
              playsInline
              className="big-product-img__pict"
              style={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
              }}
            >
              <source
                src="./assets/images/video/WhatsApp Video 2025-02-07 at 14.27.06_01421e7d.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="prod-description-featured">
            <div className="div-block-33">
              <h3 className="heading-accent">Our Academies</h3>
            </div>
            <div>
              <p className="paragraph mb-36">
                Our Academies at MRG Multi Sports Club is more than just turf;
                it's where dedication, teamwork, and victory unite under open
                skies.
              </p>
              <Link to="/contactus" className="button w-button">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopSales;
